import { useFormikContext } from 'formik';
import { EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { ContactLibrary } from '../../ContactLibrary';
export function Contacts(props) {
    const { onSelect } = props;
    const { setValues } = useFormikContext();
    const handleSelect = (contact) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        setValues({
            name: (_a = contact.name) !== null && _a !== void 0 ? _a : '',
            firstName: (_b = contact.firstName) !== null && _b !== void 0 ? _b : '',
            lastName: (_c = contact.lastName) !== null && _c !== void 0 ? _c : '',
            email: (_d = contact.email) !== null && _d !== void 0 ? _d : '',
            mobile: (_e = contact.mobile) !== null && _e !== void 0 ? _e : '',
            label: (_f = contact.label) !== null && _f !== void 0 ? _f : '',
            title: (_g = contact.title) !== null && _g !== void 0 ? _g : '',
            type: EsigningRecipientType.Signatory,
            authenticationMode: (_h = contact.authenticationMode) !== null && _h !== void 0 ? _h : undefined,
        });
        onSelect();
    };
    return <ContactLibrary onSelect={handleSelect}/>;
}
